import { normalize } from 'normalizr'
import { Schemas } from '@redux/schema'
import { updateEntities } from '@redux/entities'

import api from '@functions/api'

import type { AutoOrderQueueStatusModel } from '@models/types'
import type { AppDispatch } from '@redux/store'
import type {
  Action, Errors, FetchRequestPayload,
} from '@redux/modules/types'

import { handleError } from '../utils'

const FETCH_REQUEST = 'realbase/autoOrderQueueStatus/FETCH_REQUEST'
const FETCH_SUCCESS = 'realbase/autoOrderQueueStatus/FETCH_SUCCESS'
const FETCH_FAILURE = 'realbase/autoOrderQueueStatus/FETCH_FAILURE'

export type AutoOrderQueueStatusModuleState = {
  errors: string[],
  loaded: boolean,
  loading: boolean,
}

// Initial State
const initialState: AutoOrderQueueStatusModuleState = {
  errors: [],
  loaded: false,
  loading: false,
}

// Actions
export function fetchRequest(payload: FetchRequestPayload = {}) {
  return {
    type: FETCH_REQUEST,
    loadedIds: payload.loadedIds,
  }
}

export function fetchSuccess() {
  return {
    type: FETCH_SUCCESS,
  }
}

export function fetchFailure(errors: Errors = []) {
  return {
    type: FETCH_FAILURE,
    errors,
  }
}

// Action Creators
export function loadAutoOrderQueueStatuses() {
  return (dispatch: AppDispatch) => {
    dispatch(fetchRequest())

    const promise = api('/references/auto-order-queue-statuses')
      .then(({ data }: { data: AutoOrderQueueStatusModel[] }) => {
        const normalizedJson = normalize(data, Schemas.AUTO_ORDER_QUEUE_STATUS_ARRAY)
        dispatch(updateEntities(normalizedJson))
        dispatch(fetchSuccess())

        return { success: true as const, data }
      })
      .catch((data) => {
        const errors = handleError(data)
        dispatch(fetchFailure(errors))

        return { success: false as const, errors }
      })

    return promise
  }
}

// Reducer
export default function reducer(
  state: AutoOrderQueueStatusModuleState = initialState,
  action: Action = { type: '' },
): AutoOrderQueueStatusModuleState {
  switch (action.type) {
    case FETCH_REQUEST:
      return {
        ...state,
        loading: true,
      }
    case FETCH_SUCCESS:
      return {
        ...state,
        loading: false,
        loaded: true,
        errors: [],
      }
    case FETCH_FAILURE:
      return {
        ...state,
        loading: false,
        loaded: false,
        errors: action.errors || [],
      }
    default:
      return state
  }
}
